"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalWithActions_module_css_1 = __importDefault(require("./ModalWithActions.module.css"));
const web_sds_c_1 = require("@snapchat/web-sds-c");
/**
 * React component to render a modal at the center of the screen with two options cancel & action buttons
 */
function Modal({ children, showModal, setShowModal, title, cancelTitle, actionTitle, onAction, onCancel, cancelButtonStyle, actionButtonStyle, buttonContainerStyle, setShowModalOnActionClick = true, }) {
    const cancelStyle = `${ModalWithActions_module_css_1.default.button} ${cancelButtonStyle ?? ""}`;
    const actionStyle = `${ModalWithActions_module_css_1.default.button} ${actionButtonStyle ?? ""}`;
    const modalRef = (0, react_1.useRef)(null);
    const onCancelClick = () => {
        setShowModal((prev) => !prev);
        onCancel?.();
    };
    const closeModal = (e) => {
        if (modalRef.current === e.target) {
            setShowModal(false);
        }
    };
    const onActionClick = () => {
        if (setShowModalOnActionClick)
            setShowModal((prev) => !prev);
        onAction?.();
    };
    const keyPress = (0, react_1.useCallback)((e) => {
        if (e.key === "Escape" && showModal) {
            setShowModal(false);
        }
    }, [setShowModal, showModal]);
    (0, react_1.useEffect)(() => {
        document.addEventListener("keydown", keyPress);
        return () => document.removeEventListener("keydown", keyPress);
    }, [keyPress]);
    const contentClass = `${ModalWithActions_module_css_1.default.content} ${ModalWithActions_module_css_1.default.contentBase}`;
    const modalComp = ((0, jsx_runtime_1.jsx)("div", { className: ModalWithActions_module_css_1.default.container, onClick: closeModal, ref: modalRef, children: (0, jsx_runtime_1.jsxs)("div", { className: contentClass, children: [(0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H3", children: (0, jsx_runtime_1.jsx)("span", { className: ModalWithActions_module_css_1.default.heading, children: title }) }), (0, jsx_runtime_1.jsx)("div", { className: ModalWithActions_module_css_1.default.children, children: children }), (0, jsx_runtime_1.jsxs)("div", { className: `${ModalWithActions_module_css_1.default.buttonContainer} ${buttonContainerStyle ?? ""}`, children: [cancelTitle && ((0, jsx_runtime_1.jsx)(web_sds_c_1.ButtonOrLink, { className: cancelStyle, onClick: onCancelClick, children: cancelTitle })), actionTitle && ((0, jsx_runtime_1.jsx)(web_sds_c_1.ButtonOrLink, { className: actionStyle, onClick: onActionClick, children: actionTitle }))] })] }) }));
    return showModal ? modalComp : null;
}
exports.default = Modal;
//# sourceMappingURL=index.js.map